module.exports = __webpack_public_path__ + "img/11.d8cbffd7.png";